import axios from 'axios'
import Vue from 'vue'

const requestFunc = config => {
  if (config.method.toLowerCase() === 'get') {
    config.params = config.params || {}
    config.params['language'] = config.params['language'] || Vue.config.lang
  } else if (config.method.toLowerCase() === 'post') {
    config.data = config.data || {}
    config.data['language'] = config.data['language'] || Vue.config.lang
  }
  return config
}

const requestError = error => {
  return Promise.reject(error)
}

axios.interceptors.request.use(requestFunc, requestError)
